export default {"src":"/_next/static/media/telegram.eca7ce9b.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};